import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-all-notes-dialog',
  templateUrl: './all-notes-dialog.component.html'
})
export class AllNotesDIalogComponent implements OnInit {

  title: string;
  message: string;
  selected_files: [];
  notes: [];

  constructor(
    private dialogRef: MatDialogRef<AllNotesDIalogComponent>,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) { title, message, confirm_action, selected_files, notes }
  ) {
    this.title = title;
    this.message = message;
    this.selected_files = selected_files;
    this.notes = notes
  }

  ngOnInit() {
    console.log("All Notes:", this.notes);
  }

  close() {
    this.dialogRef.close()
  }

}
